module.exports = __webpack_public_path__ + "static/img/celoscope-detail-5.fc1f474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-5.jpg
// module id = m7G0
// module chunks = 52